export const DIGITAL_ATTENDANCE_HEIGHT_MESSAGE = 'furgediak:digital-attendance:height';
export const DIGITAL_ATTENDANCE_HEIGHT_REQUEST = 'furgediak:digital-attendance:request-height';

const MIN_IFRAME_HEIGHT = 360;
const MAX_IFRAME_HEIGHT = 100000;
const HEIGHT_PADDING = 2;

export function getDigitalAttendanceOrigin(url, baseUrl) {
    try {
        return new URL(url, baseUrl).origin;
    } catch (error) {
        return null;
    }
}

export function getDigitalAttendanceHeight(event, iframeWindow, expectedOrigin) {
    if (!iframeWindow || !expectedOrigin) return null;
    if (event.source !== iframeWindow || event.origin !== expectedOrigin) return null;
    if (event.data?.type !== DIGITAL_ATTENDANCE_HEIGHT_MESSAGE) return null;

    const reportedHeight = Number(event.data.height);
    if (!Number.isFinite(reportedHeight) || reportedHeight <= 0) return null;

    return Math.min(
        MAX_IFRAME_HEIGHT,
        Math.max(MIN_IFRAME_HEIGHT, Math.ceil(reportedHeight) + HEIGHT_PADDING)
    );
}

